module.exports = __webpack_public_path__ + "static/media/ct.30bf1903.svg";